/**
 * @file paddle Wave Summit 2020 活动卡片
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, { useMemo } from 'react';
import { Coreprops } from './type';
import './style.less'

const ActiveList: React.FC<Coreprops> = (props) => {
    const list = useMemo(() => {
        return props.list || [];
    }, [props.list]);




    return (
        <div className="paddlenlp-core">

            <div className="active-card-wrapper">
                {
                    list.map(item =>
                        <a href={item.btnLink} target="blank" className="active-btn">
                            <div className="paddlenlp-map">
                                <div className="paddlenlp-background">
                                    <div
                                        className="paddlenlp-picture-card-img"
                                        style={{ backgroundImage: item.imageUrl ? `url(${item.imageUrl})` : undefined }}
                                    />
                                </div>
                                <div className="paddlenlp-content">
                                    <p className="content-title">{item.title}</p>
                                    <p className="content-cont">{item.text}</p>
                                    <div className="content-link">
                                        <a href={item.btnLink} ><div className="content-btn">{item.btnText}</div></a>
                                        <a href={item.btnLinkt} ><div className="content-btn">{item.btnTextt}</div></a>
                                    </div>
                                </div>
                            </div>
                        </a>

                    )
                }

            </div>

        </div>
    );
};

export default ActiveList;
